export const links = [
  {
    text: "About",
    url: "/about",
  },
  {
    text: "Rooms",
    url: "/rooms",
  },
  {
    text: "Attractions",
    url: "/attractions",
  },
  {
    text: "Contact Us",
    url: "/contact",
  },
];
